import { render, staticRenderFns } from "./TagCustomerList.vue?vue&type=template&id=19e23c23&scoped=true&"
import script from "./TagCustomerList.vue?vue&type=script&lang=js&"
export * from "./TagCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./TagCustomerList.vue?vue&type=style&index=0&id=19e23c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e23c23",
  null
  
)

export default component.exports